import { MessageCircle } from 'lucide-react'

interface SuggestedQuestionsProps {
  questions: string[]
  onQuestionClick: (question: string) => void
}

export default function SuggestedQuestions({ questions, onQuestionClick }: SuggestedQuestionsProps) {
  return (
    <div className="mb-4 sm:mb-6">
      <div className="flex items-center space-x-2 mb-3">
        <MessageCircle size={16} className="text-blue-400 sm:w-5 sm:h-5" />
        <h3 className="text-base sm:text-lg font-semibold text-white">
          こんなことを聞いてみませんか？
        </h3>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        {questions.map((question, index) => (
          <button
            key={index}
            onClick={() => onQuestionClick(question)}
            className="glass-suggestion text-left p-3 text-xs sm:text-sm text-gray-200 hover:text-white"
          >
            {question}
          </button>
        ))}
      </div>
    </div>
  )
}